import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Column, Card, Button, AppText, Header } from '@streem/ui-react';
export const LocationBlocked = ({ dismiss, }) => {
    return (_jsx(Card, { children: _jsxs(Column, { children: [_jsx(Header, { bold: true, size: "large", style: { marginBottom: '1rem' }, children: "GPS Location Blocked" }), _jsx(Text, { as: "p", light: true, children: "Your GPS location could not be shared because you have GPS permissions turned off." }), _jsx(ConfirmButton, { variant: "primary", onClick: dismiss, children: "OK" })] }) }));
};
const Text = styled(AppText) `
    margin-bottom: 1rem;
`;
const ConfirmButton = styled(Button) `
    align-self: flex-end;
`;
//# sourceMappingURL=location_blocked.js.map